import { PaymentMethodEnum } from '@pe/checkout/types';

export const PAYMENTS_NO_EXTERNAL_CODE: PaymentMethodEnum[] = [
  PaymentMethodEnum.SANTANDER_POS_INSTALLMENT,
];
